import { render, staticRenderFns } from "./CoupleMassages.vue?vue&type=template&id=280a76f2&"
import script from "./CoupleMassages.vue?vue&type=script&lang=js&"
export * from "./CoupleMassages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports